module.exports = __webpack_public_path__ + "img/ORcode.9480114e.jpg";